export default "__VITE_ASSET__e866723c__"